import type { HttpClient } from '@angular/common/http';

import { TranslateHttpLoader } from '@ngx-translate/http-loader';

/** For HttpLoader / translating pages, required for AOT compilation */
export const HttpLoaderFactory = (http: HttpClient): TranslateHttpLoader => new TranslateHttpLoader(http, '../assets/i18n/', `.json?ts=${Date.now()}`);
